// Handle close form click
export function handleCloseFormClick() {
  const slideFormElements = document.querySelectorAll(
    '.slideForm, .slideFormAlpine',
  );
  Array.from(slideFormElements).forEach((slideForm) =>
    slideForm.classList.remove('open'),
  );

  // Remove 'selected' class from all booking items
  const selectedItems = document.querySelectorAll(
    '.calendar-tour-booking-item, .calendar-accomm-booking-item',
  );
  selectedItems.forEach((item) => {
    item.classList.remove('selected');
    item.style.zIndex = '1';
  });

  // Deactivate backdrop
  document.getElementById('backdrop').style.display = 'none';
  document.body.classList.remove('slideform-open'); // This is to prevent the background from scrolling when the form is open
}
